//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    value: {
      type: Boolean,
      required: false,
      default: false,
    },
    attribute: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  methods: {
    select(event) {
      this.$emit('input', event.target.checked ? true : undefined);
    },
  },
};
